import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { buildLoginPath } from '../utils/authRedirect';

function ProtectedRoute({ children }) {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="flex items-center justify-center p-xl">Loading...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to={buildLoginPath(location)} replace />;
    }

    return children;
}

export default ProtectedRoute;
